import { Button, Popover, Stack, Tooltip } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import { useState } from "react";
import { downloadEML } from "../../../../../api/PRMAPI";
import { useLanguage } from "../../../../../stores/LanguageStore";

const AnswerDownloader = ({ item }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(null);

  const handleDownloadHTML = () => {
    setLoading("html");
    const blob = new Blob([item?.reply || item?.message], {
      type: "text/html",
    });
    // Create a link element
    const link = document.createElement("a");

    // Set the href attribute of the link to the Blob
    link.href = window.URL.createObjectURL(blob);

    // Set the download attribute and file name
    link.download = "Answer.html";

    // Append the link to the document
    document.body.appendChild(link);

    // Trigger a click on the link to start the download
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
    setLoading(null);
  };
  const handleDownloadEML = () => {
    setLoading("eml");
    downloadEML({
      reply_id: item.id,
      id: item?.history_type === "sent" ? item?.id : undefined,
    })
      .then((res) => {
        const url = window.URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Answer #${item.id}`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      })
      .finally(() => setLoading(null));
  };

  return (
    <Popover opened={opened} onChange={setOpened} withinPortal={false}>
      <Popover.Target>
        <Tooltip label={lang.files.download}>
          <Button
            variant="light"
            onClick={(e) => {
              e.stopPropagation();
              setOpened(true);
            }}
            size="compact-sm"
            ml={"auto"}
          >
            <IconDownload size={18} />
          </Button>
        </Tooltip>
      </Popover.Target>

      <Popover.Dropdown p={"xs"}>
        <Stack gap={0}>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              handleDownloadHTML();
            }}
            loading={loading === "html"}
            variant="subtle"
          >
            .html
          </Button>
          {item.id && (
            <Button
              onClick={(e) => {
                e.stopPropagation();
                handleDownloadEML();
              }}
              loading={loading === "eml"}
              variant="subtle"
            >
              .eml
            </Button>
          )}
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};

export default AnswerDownloader;
